import { UploadOutlined } from "@ant-design/icons";
import { Button, Descriptions, Divider, Drawer, Form, Typography, Upload, message } from "antd";
import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db, storage } from "../../../firebase/config";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

const { Dragger } = Upload;
const { Text, Link } = Typography;

export default function TapeTechnicalReqDetails({ priceData }) {
  const [open, setOpen] = useState(false);
  //technical page file
  const [uploadedFile, setUploadedFile] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);

  // upload and accept technical
  const uploadAndAcceptTechnical = async () => {
    setButtonLoading(true);
    const docref = doc(db, "tapePrices", priceData.id);

    try {
      const file = uploadedFile;

      if (!file) {
        message.error("Please select a file to upload.");
        return; // Exit if no file is selected
      }

      const filePath = `tapePrices/${priceData.id}/${file.name}`;
      const storageRef = ref(storage, filePath);
      await uploadBytesResumable(storageRef, file);

      // Use the created reference to get the download URL
      const downloadURL = await getDownloadURL(ref(storage, filePath));
      await updateDoc(docref, {
        technicalPage: downloadURL,
        hasTechincalPage: 2,
      });

      message.success("Technical Added!");
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error("Error:", error);
      message.error(error.message);
    } finally {
      setButtonLoading(false);
    }
  };

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      setUploadedFile(file);
      return false; // return false to prevent automatic upload
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  //init form
  const [form] = Form.useForm();

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onFinish = (values) => {
    uploadAndAcceptTechnical();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Button size="small" type="primary" onClick={showDrawer}>
        Show
      </Button>
      <Drawer title="Product details" placement="left" onClose={onClose} open={open}>
        <Divider>Print details</Divider>

        <Descriptions size="small" column={1}>
          <Descriptions.Item label="Label Width">{priceData.tapeWidth}</Descriptions.Item>
          <Descriptions.Item label="Manager">{priceData.userEmail}</Descriptions.Item>
          <Descriptions.Item label="Format Width">{priceData.formatWidth}</Descriptions.Item>
          <Descriptions.Item label="Material">{priceData.material}</Descriptions.Item>
          <Descriptions.Item label="User File">
            <Link href={priceData.product.productFileUrl} target="_blank">
              Link
            </Link>
          </Descriptions.Item>
        </Descriptions>

        <Divider>Add Technical</Divider>
        <Form
          form={form}
          initialValues={{
            remember: true,
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}
        >
          <Form.Item
            label="Technical Page"
            name="technicalPage"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <Dragger {...props}>
              <UploadOutlined />
              <Text>Please click or drag to upload</Text>
            </Dragger>
          </Form.Item>
          <Form.Item>
            <Button block type="primary" loading={buttonLoading} htmlType="submit">
              Upload & Approve
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}
